import { AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {debounceTime, distinctUntilChanged, forkJoin, Subject, Subscription} from 'rxjs';
import { DataManipulationService } from 'src/app/services/data-manipulation.service';

@Component({
  selector: 'app-to-page-body',
  templateUrl: './to-page-body.component.html',
  styleUrls: ['./to-page-body.component.scss']
})
export class ToPageBodyComponent implements OnInit, DoCheck {
  @HostListener('document:click', ['$event']) 
  onDocumentClick(event: MouseEvent) {
    if (this.highlightedTeam && !this.confirmationModalOpen) {
      this.highlightedTeam.showQuickActions = false;
    }
    if (this.openFilterByScore) {
      this.openFilterByScore = false;
    }
    if (this.openFilterByTeams) {
      this.openFilterByTeams = false;
      this.teamToSearch = null;
      this.searchingTeam.next('');
    }
    if (this.selectedView && this.selectedView.openSettings) {
      this.selectedView.openSettings = false;
      this.memberToSearch = null;
      this.searchingMember.next('');
    }
    if (this.selectedView && this.selectedView.openCreatorView) {
      this.selectedView.openCreatorView = false;
    }
  }

  @ViewChild('teamQuickActions') teamQuickActions!: ElementRef<HTMLElement>;
  @ViewChild('viewSettingsMenu') viewSettingsMenu!: ElementRef<HTMLElement>;

  @Input() set teamsForOverview(value:any) {
    if (value && (value?.availableTeams.length && value?.backupTeams.length && value?.currentTeams.length)) {
      this.teams = value.currentTeams;
      this.defaultTeams = value.backupTeams;
      this.availableTeams = value?.availableTeams;
      this.getUserRoles();
    }
  }
  @Input() set aggregatedScoresSetter(value: any) {
    if (value) {
      this.aggregatedScores = value;
      this.aggregatedHasValue = true;
    }
  }
  @Input() set indicatorToShow(value: string) {
    this.indicatorForSort = value;
    this.openFilterByScore = false;
    this.openAggregated = false;
    this.openAggregatedOnce = false;
  }
  @Input() set userViewFilters(value: any) {
    if (value) {
      this.views = value;
    }
  }
  @Input() set membersToShareView(value: any) {
    if (value) {
       this.memberSearchedToShareView = value;
       this.showMembersLoading = false;
    }
  }
  @Input() set setSelectedViewAfterChanges(value: any) {
    this.selectedView = value;
  }
  @Input() changesToView: boolean = false;

  @Output() quickActionsOpened = new EventEmitter<any>();
  @Output() goToTeamDashboard = new EventEmitter<any>();
  @Output() setFilterForScore = new EventEmitter<any>();
  @Output() teamFilterCheck = new EventEmitter<any>();
  @Output() getAggregatedScores = new EventEmitter<any>();
  @Output() pauseLoopEvent = new EventEmitter<any>();
  @Output() removeMemberEvent = new EventEmitter<any>();
  @Output() createNewViewEvent = new EventEmitter<any>();
  @Output() openViewEvent = new EventEmitter<any>();
  @Output() patchViewEvent = new EventEmitter<any>();
  @Output() deleteViewEvent = new EventEmitter<any>();
  @Output() searchMemberViewEvent = new EventEmitter<any>();
  @Output() shareViewWithMemberEvent = new EventEmitter<any>();
  @Output() removeMemberFromViewEvent = new EventEmitter<any>();
  @Output() saveViewChangesEvent = new EventEmitter<any>();

  searchingMember = new Subject<string>();
  searchingTeam = new Subject<string>();

  highlightedTeam: any;
  selectedRadioValue: any;
  selectedView: any | null = null;
  tempViewTitle: any | null = null;
  firstSelectedRadioValue: any;
  lastSelectedRadioValue: any;
  aggregatedScores: any | null = null;
  memberToDelete: any | null = null;
  memberToSearch: any | null = null;
  teamToSearch: any | null = null;
  memberToShareView: any | null = null;
  viewConfirmationPopupPosition: any | null = null;
  selectAllTeams: any | null = null;
  teamsPlaceholder: any | null = null;

  indicatorForSort: string = '';

  shouldOpenLeft: boolean = false;
  openFilterByScore: boolean = false;
  openFilterByTeams: boolean = false;
  openAggregated: boolean = false;
  openAggregatedOnce: boolean = false;
  aggregatedHasValue: boolean = false;
  bottomScroll: boolean = false;
  middleScroll: boolean = false;
  loadedOnce: boolean = false;
  confirmationModalOpen: boolean = false;
  pauseLoopModalOpen: boolean = false;
  deleteMemberModalOpen: boolean = false;
  showMembersLoading: boolean = false;
  saveViewButton: boolean = false;
  shareViewWithMemberConfirmation: boolean = false;

  teams: any = [];
  defaultTeams: any[] = [];
  availableTeams: any[] = [];
  views: any[] = [];
  memberSearchedToShareView: any[] = [];
  filterOptions: {name: string, checked: boolean}[] = [
    {name: this.translate.instant('team_overview_high'), checked: false},
    {name: this.translate.instant('team_overview_low'), checked: false}
  ];
  radioButtons: any[] = [
    {label: this.translate.instant('team_overview_high'),slug: 'highest', id: 'radio1', value: 'DESC'},
    {label: this.translate.instant('team_overview_low'),slug: 'lowest', id: 'radio2', value: 'ASC'}];

  constructor(public data: DataManipulationService, private translate: TranslateService) {
    this.searchingMember.pipe(
        debounceTime(800),
        distinctUntilChanged()).subscribe((value: any) => {
          this.memberSearchedToShareView = [];
          this.showMembersLoading = true;
          if (value !== '') {
            this.searchMemberViewEvent.emit(value);
          }
        });
    this.searchingTeam.pipe(
      distinctUntilChanged()).subscribe((value: any) => {
        const lowerTerm = value.toLowerCase().trim();
        if (!value) {
          this.availableTeams.map((team: any) => team.searched = true);
          return;
        }
        this.availableTeams.map((team: any) => {
          team.searched = true;
          if (!(team.name.toLowerCase().includes(lowerTerm))) {
            team.searched = false;
          }
        });
      });
  }

  ngDoCheck(): void {
    if (this.highlightedTeam?.gotMembers && !this.loadedOnce) {
      this.loadedOnce = true;
      setTimeout(() => {
        this.adjustPosition();
      })
    }
  }

  ngOnInit(): void {
    this.selectedRadioValue = this.radioButtons[1];
    this.teamsPlaceholder = this.translate.instant('to_sort_by_teams');
    this.selectAllTeams = true;
  }

  private getUserRoles() {
    if (this.teams.length) {
      if (this.data.userRole.role.workspacePriority > 10) {
        this.teams.forEach((team: any) => {
          team.userHasAccess = true;
        });
      } else {
        this.teams.forEach((team: any) => {
          if (this.data.userRole.teams.filter((teamToFilter: any) => team.teamUuid === teamToFilter.team.uuid).length) {
            const role = this.data.userRole.teams.filter((teamToFilter: any) => team.teamUuid === teamToFilter.team.uuid)[0].team.myRole;
            team.userHasAccess = role.teamPriority >= 20;
          }
        });
      }
    }
  }

  highlightTeamAndDoQuickActions(team: any) {
    this.highlightedTeam = team;
    this.highlightedTeam.showQuickActions = true;
    this.bottomScroll = false;
    this.loadedOnce = false;
    if (!this.highlightedTeam.gotMembers) {
      this.quickActionsOpened.emit(this.highlightedTeam);
    }
  }

  closeTeamQuickActions() {
    this.highlightedTeam.showQuickActions = false;
  }

  setMemberToDelete(member: any, event: MouseEvent) {
    this.memberToDelete = member;
    this.openConfirmationModal('deleteMember', event);
  }

  openConfirmationModal(modeToOpen: string, event: MouseEvent) {
    event.stopPropagation();
    document.body.style.overflow = 'hidden';
    this.pauseLoopModalOpen = modeToOpen === 'pauseLoop';
    this.deleteMemberModalOpen = modeToOpen === 'deleteMember';
    this.confirmationModalOpen = true;
  }

  pauseLoopModal() {
    this.pauseLoopEvent.emit(this.highlightedTeam);
    this.pauseLoopModalOpen = false;
    this.confirmationModalOpen = false;
  }

  removeMember(removeFrom: string, event: MouseEvent) {
    event.stopPropagation();
    this.removeMemberEvent.emit({type: removeFrom, member: this.memberToDelete, team: this.highlightedTeam});
    this.closeConfirmationModal();
  }

  closeConfirmationModal() {
    this.confirmationModalOpen = false;
    this.pauseLoopModalOpen = false;
    this.deleteMemberModalOpen = false;
    document.body.style.overflow = '';
  }

  gotToTeamDashboard() {
    this.goToTeamDashboard.emit(this.highlightedTeam.teamUuid);
  }

  onTeamCheckChange(teamUuid: string, event: any) {
    this.teamFilterCheck.emit({teamUuid, checked: event.target.checked});
    if (this.openAggregated && this.openAggregatedOnce) {
      this.aggregatedHasValue = false;
      this.getAggregatedScores.emit('');
    }
    this.teamsPlaceholder = this.getTeamsCheckState;
  }

  openScoreFilterContainer() {
    this.openFilterByScore = true;
    this.openFilterByTeams = false;
  }

  openTeamFilterContainer() {
    this.openFilterByTeams = true;
    this.openFilterByScore = false;
  }

  setFilterByScore() {
    this.openFilterByScore = false;
    this.setFilterForScore.emit(this.selectedRadioValue?.value);
  }

  seeWhy(teamUuid: any) {
    this.goToTeamDashboard.emit(teamUuid);
  }

  diselectAllTeams(event: any) {
    this.selectAllTeams = event.target.checked;
    this.availableTeams.forEach((team: any) => {
      this.onTeamCheckChange(team.uuid, event);
    });
  }

  get getTeamsCheckState(): string | null {
    const total = this.availableTeams.length;
    const checkedCount = this.teams.filter((team: any) => team.checked).length;
    const isModified = this.teams.some((team:any, index:number) => {
      const originalItem = this.defaultTeams.find((item: any) => item.teamUuid === team.teamUuid);
      return originalItem ? originalItem.checked !== team.checked : true;
    });
    return isModified ? `${checkedCount}/${total} teams` : this.translate.instant('to_sort_by_teams');
  }

  createNewView() {
    this.createNewViewEvent.emit({title:'New View',newView: true,byScore: this.selectedRadioValue.value});
    if (this.selectedView) this.selectedView.openSettings = false;
  }

  saveViewChanges() {
    this.saveViewChangesEvent.emit(true);
  }

  searchMember(event: any) {
    this.searchingMember.next(event);
    this.memberToShareView = null;
  }

  searchTeam(event: any) {
    this.searchingTeam.next(event);
  }

  selectView(view: any) {
    if ((!view && this.selectedView) || (view && this.selectedView && this.selectedView !== view)) {
      this.selectedView.openSettings = false;
      this.selectedView.openCreatorView = false;
    }
    if (view) {
      this.selectedRadioValue = this.radioButtons[view.byScore === 'ASC' ? 1:0];
    } else if (!view) {
      this.selectedRadioValue = this.radioButtons[1];
    }
    this.saveViewButton = !!view && view.creatorPermission;
    this.selectedView = view;
    this.openViewEvent.emit(view);
    this.teamsPlaceholder = this.getTeamsCheckState;
  }

  openViewSettingsMenu(view: any) {
    this.selectView(view);
    view.openSettings = true;
    if (this.selectedView && this.selectedView !== view) {
      this.selectedView.openSettings = false;
    }
    this.tempViewTitle = view.viewTitle;
  }

  openViewCreatorMenu(view: any) {
    this.selectView(view);
    view.openCreatorView = true;
    if (this.selectedView && this.selectedView !== view) {
      this.selectedView.openCreatorView = false;
    }
  }

  changeSelectedViewTitle(view: any) {
    if (this.selectedView.viewTitle !== this.tempViewTitle) {
      view.viewTitle = this.tempViewTitle;
      this.patchViewEvent.emit({view: view, body:{name: this.tempViewTitle}});
    }
  }

  deleteView(viewToDelete: any) {
    this.selectView(null);
    this.deleteViewEvent.emit(viewToDelete.viewUuid);
  }

  shareViewWithUser(member: any) {
    this.memberToShareView = member;
  }

  shareViewConfirmation(confirmation: any) {
    if (confirmation === 'yes') {
      this.shareViewWithMemberEvent.emit({view: this.selectedView, member: this.memberToShareView});
      this.memberToSearch = null;
    }
    this.memberToShareView = null;
  }

  removeMemberFromView(memberToRemove: any, view: any) {
    this.removeMemberFromViewEvent.emit({memberUuid: memberToRemove.uuid, view: view});
  }

  adjustPosition() {
    if (this.bottomScroll) return;
    const rect = this.teamQuickActions.nativeElement.getBoundingClientRect();
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const elementBottom = rect.bottom + scrollTop;
    const documentHeight = Math.max(document.documentElement.scrollHeight,document.body.scrollHeight);
    const padding = 24;

    const shouldMoveUp = (elementBottom + padding) > documentHeight;
    if ((rect.top - padding) <= 306 && shouldMoveUp) {
      this.middleScroll = true;
    } else if (shouldMoveUp) {
      this.bottomScroll = true;
    }
  }

  showSidePanel(triggerEl: HTMLElement, team: any) {
    const rect = triggerEl.getBoundingClientRect();
    const panelWidth = 300;
    const padding = 52;
    const spaceRight = window.innerWidth - rect.right;

    this.shouldOpenLeft = spaceRight < (panelWidth + padding);
  }

  openAggregatedReports() {
    if (!this.openAggregatedOnce) this.getAggregatedScores.emit('');
    this.openAggregatedOnce = true;
    this.openAggregated = !this.openAggregated;
  }

  getPollingTimeRemaining(endDate: any) {
    if (endDate !== null) {
      const today = new Date();
      const expireDate = new Date(endDate.slice(5, 7) + '/' + endDate.slice(8, 10) + '/' + endDate.slice(0, 4));
      return Math.floor((Date.UTC(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / (1000 * 60 * 60 * 24));
    } else {
      return 0
    }
  }

  getRgba(hex: string, alpha: number = 1): string {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    if (hex.length !== 6) throw new Error('Hex code invalid');

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
